import ApiRequest from "../util/ApiRequest";

export default class Strings {
    get = async () => {
        return await ApiRequest.set(`/v1/strings`, "GET");
    }
}
